import axios from "axios";

const API_VERSION = process.env.VUE_APP_API_VERSION;
const API_SCRIPT = process.env.VUE_APP_API_SCRIPT;
const API_PRODUCTS_SCRIPT = process.env.VUE_APP_API_PRODUCTS_SCRIPT;
const API_BASEURL = process.env.VUE_APP_API_BASEURL;
const API_URL = API_BASEURL + API_VERSION + "/" + API_SCRIPT;

const ApiService = {
  init() {
    axios.defaults.baseURL = API_URL;
    this.initialized = true;
  },
  initialized: false,

  getProducts() {
    axios.defaults.baseURL = API_BASEURL + API_PRODUCTS_SCRIPT;
    return axios.get();
  },
  get(resource) {
    if (!this.initialized) {
      this.init();
    }
    console.log("ApiService.get():", resource);
    return axios.get(resource);
  },
  post(resource, data) {
    if (!this.initialized) {
      this.init();
    }
    return axios.post(resource, data);
  },
  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    if (!this.initialized) {
      this.init();
    }
    return axios(data);
  }
};

export default ApiService;
